import { useEffect, useEffectEvent } from "react";
import { useNavigate } from "react-router";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER } from "../../../constants/routes";
import { useEvents } from "../../../hooks";
import { useMarketSpotlightPageLayout } from "../../../hooks/api/v2/marketSpotlightLayout/useMarketSpotlightPageLayout";
import { useMarketStorefrontSessionId } from "../../../hooks/useMarketStorefrontSessionTracking";
import { SpotlightListCollectionCard } from "../SpotlightListCollection/SpotlightListCollectionCard";

export const RegionalSpotlightOverviewPage = () => {
  const navigate = useNavigate();
  const { sessionId } = useMarketStorefrontSessionId();
  const { track } = useEvents();
  const marketSpotlightPageLayoutQuery = useMarketSpotlightPageLayout({
    type: "regional",
  });

  const pageIds = marketSpotlightPageLayoutQuery.data?.pageIds;

  const trackPageView = useEffectEvent(() => {
    track("Regional Spotlight List Viewed", {
      sessionId,
    });
  });

  useEffect(() => {
    trackPageView();
  }, []);

  if (!pageIds?.length) return null;
  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={`Regional spotlights`}
      />
      <div className="flex items-center justify-center p-4">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          {pageIds.map((pageId, index) => (
            <div key={pageId} className={"col-span-1 gap-4"}>
              <SpotlightListCollectionCard
                pageId={pageId}
                key={index}
                type={"regional"}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
